import { render, staticRenderFns } from "./CuotasPagadas.vue?vue&type=template&id=796b24f7"
import script from "./CuotasPagadas.vue?vue&type=script&lang=js"
export * from "./CuotasPagadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports